import * as React from 'react';
import ChatBubbleProps from './interface';
import {Box, Image, Text} from 'rebass'
import styles from './styles';

const defaultBubbleStyles = {
  userBubble: {},
  chatbubble: {},
  text: {},
};

export default class ChatBubble extends React.Component {
  props;

  constructor(props: ChatBubbleProps) {
    super(props);
  }

  public render() {
    const { bubblesCentered, message , scrollTrigger} = this.props;
    let { bubbleStyles } = this.props;
    bubbleStyles = bubbleStyles || defaultBubbleStyles;
    const { userBubble, chatbubble, text } = bubbleStyles;

    // message.id 0 is reserved for blue
    const chatBubbleStyles =
      this.props.message.id === 0
        ? {
            ...styles.chatbubble,
            ...bubblesCentered ? {} : styles.chatbubbleOrientationNormal,
            ...chatbubble,
            ...userBubble,
          }
        : {
            ...styles.chatbubble,
            ...styles.recipientChatbubble,
            ...bubblesCentered
              ? {}
              : styles.recipientChatbubbleOrientationNormal,
            ...chatbubble,
            ...userBubble,
          };

    let textColor = this.props.message.id === 0 ? 'white' : 'black'
    return (
      <Box p={1}
        style={{
          ...styles.chatbubbleWrapper,
        }}
      >
        <div style={chatBubbleStyles}>
          <Text css={{ ...styles.p, ...text }}  color={textColor}>{this.props.message.message}</Text>
            {message.has_attachment === true && <React.Fragment>
                {message.type === 'image' ?
                    <p style={{ ...styles.p, ...text }}><a href={message.attachment} download={`${message.file_name ? message.file_name : 'chat-attachment'}`} target='_blank'><Image   p={0} m={0} src={message.attachment}  borderRadius={2}/></a></p> :
                    <a href={message.attachment} download='wave-attachment' target='_blank'>Download {message.file_name ? message.file_name : 'file'}</a>
                }
            </React.Fragment>}
        </div>
      </Box>
    );
  }
}
// @ts-ignore
export { ChatBubbleProps };
